define([
    "jquery",
    "underscore",
    "marionette"
], function($, _, Marionette){
    /**
    HOW TO USE,
    1. Insert this dom to html
        <span id="countdown-timer"></span>

    2. Define this behavior into the loader, such as
        define([
            "jquery", "underscore", "marionette", "./countdown_behavior"
        ], function (...) { (...) })

    3. Add it to arguments, and declare this behavior.
        function($, _, Marionette, (...) , CountdownBehavior ...
        behaviors: {
            countdown: {
                behaviorClass: CountdownBehavior,
            }
        },

    4. put below code into the script controller
    into where you want to start countdown, with arguments
        this.triggerMethod('startCountdown', 3, function(){
            // callback comes here
        })
    5. to clear this html, call this method
        this.triggerMethod('stopCountdown')
    */
    return Marionette.Behavior.extend({
        options: {

        },
        ui: {
            'countdownTimer' : '#countdown-timer,.countdown-timer'
        },
        events: {

        },

        onRender: function(){
            this.countdownId = 0;
        },

        onStopCountdown : function(){
            clearInterval(this.countdownId);
            this.ui.countdownTimer.html("");
        },

        onStartCountdown: function(sec, callback){
            var seconds = sec ? sec : 300;
            var endDate = new Date().getTime() + (seconds * 1000);
            var timeString = endDate - (new Date().getTime());
            var _this = this;
            var minute = 0;
            var second = 0;
            _this.ui.countdownTimer.html(timeString);
            _this.countdownId = setInterval(function(){
                timeString = endDate - (new Date().getTime());
                minute = parseInt(timeString / 1000 / 60);
                second = parseInt(timeString/1000%60);
                showString = (minute > 9 ? minute : ("0" + minute)) +
                        ":" + (second > 9 ? second : ("0" + second));
                // showString = parseInt(timeString / 1000 / 60) + ":" + parseInt(timeString/1000%60);
                if(timeString < 0 ){
                    clearInterval(_this.countdownId);
                    _this.ui.countdownTimer.html("");
                    if(callback) callback();
                }else{
                    _this.ui.countdownTimer.html(showString);
                }
            }, 100);
        }


    });
});
